import(/* webpackMode: "eager" */ "/workspace/frameworkassure/src/app/(auth)/reset-password/page.tsx");
